import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IFieldPreferences } from '@app/components/form/services/schema-form/schema-form-interfaces';

@Component({
  selector: 'xvi-xux-event-summary',
  templateUrl: './xux-event-summary.component.html',
  styleUrls: ['./xux-event-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxEventSummaryComponent implements OnInit {
  @Input() public field: IFieldPreferences = {};

  public constructor() {}

  public ngOnInit() {}
}
